<template>
  <div id="app" v-if="product_info">
    <van-nav-bar title="" left-text="back"  left-arrow @click-left="onClickLeft"/>
    <div class="list-box ">
      <div class="title">CASHE DETAILS</div>
      <div class="flex flex-align-center flex-justify-between">
        <div class="font-16 left-text">AMOUNT TO REPAY</div>
        <div class="font-15">{{ product_info.all_amount }}</div>
      </div>
      <div class="flex flex-align-center flex-justify-between  margin-top-24">
        <div class="font-16  left-text">DUE DATE</div>
        <div class="font-15">{{ product_info.cycle }}</div>
      </div>

    </div>
    <!-- <div class="list-box ">
      <div class="title">CASHE DETAILS</div>
      <div class="flex flex-align-center flex-justify-between">
        <div class="font-16 left-text">TOTAL CASH</div>
        <div class="font-15">{{ product_info.all_amount }}</div>
      </div>
      <div class="flex flex-align-center flex-justify-between  margin-top-24">
        <div class="font-16  left-text">INTEREST</div>
        <div class="font-15">{{ product_info.all_pay }}</div>
      </div>
      <div class="flex flex-align-center flex-justify-between  margin-top-24">
        <div class="font-16  left-text">IN-HAND AMOUNT</div>
        <div class="font-15">{{ product_info.amount }}</div>
      </div>
    </div> -->
    <div class="fixed repay-box  ">
      <div class="theme-back repay" @click="firstCash">
        Withdraw Now
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      product_id: null,
      product_info: null
    }
  },
  created() {
    if (this.$route.query.product_id) { this.product_id = this.$route.query.product_id, this.getProductProductInfo(this.$route.query.product_id) }
    else this.getProductInfo()
  },
  methods: {
    onClickLeft(){
      this.$router.back()
    },
    async getProductInfo() {
      const { data: res } = await this.$http.post('/api/product/info')
      if (res.code === 0) {
        this.product_info = res.data
      } else {
        this.$toast(res.msg)
      }
    },
    async getProductProductInfo(product_id) {
      const { data: res } = await this.$http.post('/api/product/productInfo', { productId: product_id })
      if (res.code === 0) {
        this.product_info = res.data
      } else {
        this.$toast(res.msg)
      }
    },
    async firstCash() {
      if (this.product_id) {
        const { data: res } = await this.$http.post('/api/Product/apply', { productId: this.product_id })
        if (res.code === 0 || res.code === 10004) {
          this.$router.push({
            name: 'firstcashdetail',
            query: {
              product_id: this.product_id
            }
          })
        } else {
          this.$toast(res.msg)
        }
      } else {
        const { data: res } = await this.$http.post('/api/Product/firstCash')
        if (res.code === 0 || res.code === 200) {
          this.$router.push({
            name: 'firstcashdetail'
          })
        } else {
          this.$toast(res.msg)
        }
      }

    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #F9F9F9;
  min-height: 100vh;
  padding: 12px 12px 0px 12px;
  box-sizing: border-box;

  .title {
    font-size: 15px;
    color: #FFA06A;
    font-weight: 500;
    margin-bottom: 20px;
  }

  .list-box {
    background: #FFFFFF;
    padding: 14px;
    border-radius: 14px;

    .left-text {
      color: #666666;
    }
  }

  .repay-box {
    bottom: 10px;
    margin: 0 38px;
    left: 0;
    right: 0;
    text-align: center;
    box-sizing: border-box;

    .repay {
      padding: 12px 0px;
      font-size: 16px;
      color: #FFFFFF;
      font-weight: bold;
      border-radius: 24px;
    }
  }

}
</style>
